var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "min-h-screen bg-gray-50 flex flex-col justify-center items-center py-8 sm:px-6 lg:px-8",
    },
    [
      _c(
        "div",
        { staticClass: "sm:mx-auto sm:w-full sm:max-w-md" },
        [
          _c("Logo", { staticClass: "mx-auto h-12 w-auto" }),
          _vm.title
            ? _c(
                "h2",
                {
                  staticClass:
                    "mt-6 text-center text-3xl leading-9 font-extrabold text-gray-900",
                },
                [
                  _vm.skipCapitalization
                    ? _c("span", [_vm._v(" " + _vm._s(_vm.title) + " ")])
                    : _c("span", [
                        _vm._v(
                          " " + _vm._s(_vm._f("capitalize")(_vm.title)) + " "
                        ),
                      ]),
                ]
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "mt-4 justify-center" },
            [_vm._t("buttons")],
            2
          ),
        ],
        1
      ),
      _vm._t("content", function () {
        return [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.hideCard,
                  expression: "!hideCard",
                },
              ],
              staticClass: "mt-8 sm:mx-auto sm:w-full",
              class: _vm.cardClass,
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10",
                },
                [_vm._t("default")],
                2
              ),
            ]
          ),
        ]
      }),
      _vm._t("bottom"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }